import React, { Component } from "react";
import { Helmet } from "react-helmet";
import Header from "./Header";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ScrollAnimation from "react-animate-on-scroll";
import $ from "jquery";
import Axios from "axios";
import Constants from "./Constants";
// import img2014 from "../src/assets/img/ac-img/"
import img2011 from "../src/assets/img/ac-img/cbse2011.jpg";
import img2012 from "../src/assets/img/ac-img/CBSE2012.jpg";
import img2013 from "../src/assets/img/ac-img/CBSE2013.jpg";
// import img2014 from "../src/assets/img/ac-img/CBSE2014.jpg";
// import img2015 from "../src/assets/img/ac-img/CBSE2015.jpg";
// import img2016 from "../src/assets/img/ac-img/CBSE2016.jpg";
// import img2017 from "../src/assets/img/ac-img/CBSE2017.jpg";
import img2018 from "../src/assets/img/ac-img/CBSE2018.jpg";
import img2019 from "../src/assets/img/ac-img/CBSE2019.jpg";
import img2021 from "../src/assets/img/ac-img/cbse2021.jpeg";
import sb2019 from "../src/assets/img/sb/SB2019.jpg";
import sb2018 from "../src/assets/img/sb/SB2018.jpg";
import sb2017 from "../src/assets/img/sb/SB2017.jpg";
import sb2021 from "../src/assets/img/sb/state2021.jpeg";
import img2020 from "../src/assets/img/ac-img/cbsc2020.jpg";
import sb2020 from "../src/assets/img/ac-img/stateboard2020.jpg";
import sb2022 from "../src/assets/img/ac-img/state2022.jpeg";
import img2022 from "../src/assets/img/ac-img/Cbse2022.jpeg";
import sb2023 from "../src/assets/img/ac-img/state2023.jpeg";
import img2023 from "../src/assets/img/ac-img/cbse2023.jpeg";
import sb2024 from "../src/assets/img/ac-img/state2024.jpeg";
import img2024 from "../src/assets/img/ac-img/cbse2024.jpeg";
import sb2025 from "../src/assets/img/ac-img/state2025.jpg";
import img2025 from "../src/assets/img/ac-img/cbse2025.jpg";
import NewConstants from "./NewConstants";

export default class Achievers extends Component {
  state = {
    achievers: [],
    data: "",
    metaDescription: "",
    metaTitle: "",
    imgText: "",
  };
  componentDidMount() {
    window.scrollTo(0, 0);
    let data = this.props.location.state;
    let id = this.props.match.params.id;

    Axios.post(NewConstants.postUrls.courseBatchesByLevelId, {
      level_id: id,
    }).then((res) => {
      console.log(res.data);
      this.setState(
        {
          achievers: res.data.data.achievers,
          data,
          metaTitle: res.data.data.meta_key,
          metaDescription: res.data.data.meta_description,
          imgText: res.data.data.img_alt_text,
        },
        () => {
          console.log(this.state.achievers);
        },
      );
    });

    var loader = function() {
      setTimeout(function() {
        if ($("#ftco-loader").length > 0) {
          $("#ftco-loader").removeClass("show");
        }
      }, 1);
    };
    loader();
  }
  componentDidUpdate(prevProps) {
    // alert("some");
    if (prevProps.match.params.id !== this.props.match.params.id) {
      let id = this.props.match.params.id;
      Axios.post(NewConstants.postUrls.courseBatchesByLevelId, {
        level_id: id,
      }).then((res) => {
        // console.log(res.data);
        this.setState(
          {
            achievers: res.data.data.achievers,
            data: this.props.location.state,
            // description: res.data.course[0].specification
          },
          () => {
            // console.log(this.state.courses);
          },
        );
      });
    }
  }
  render() {
    return (
      <div>
        <Helmet>
          <title>
            {this.state.metaTitle !== "" &&
            this.state.metaTitle !== null &&
            this.state.metaTitle !== undefined
              ? this.state.metaTitle
              : this.state.data.name === "CA"
              ? "Trusted CA Coaching in Nagpur – VPA Edu"
              : this.state.data.name === "CS"
              ? "Top CS Coaching Institute in Nagpur – VPA Edu"
              : this.state.data.name === "XI-XII CBSE"
              ? "VPA Edu | Leading 11th-12th CBSE Commerce Classes in Nagpur"
              : this.state.data.name === "XI-XII State Board"
              ? "VPA Edu | Leading 11th-12th State Board Commerce Classes in Nagpur"
              : "11th-12th State Board Commerce Classes in Nagpur – VPA Edu"}
          </title>
          <meta
            name="description"
            content={
              this.state.metaDescription !== "" &&
              this.state.metaDescription !== null &&
              this.state.metaDescription !== undefined
                ? this.state.metaDescription
                : this.state.data.name === "CA"
                ? "Crack CA Foundation, CA Intermediate and CA Final with VPA Edu in Nagpur. Expert faculty, updated syllabus, study material, test series. Join now!"
                : this.state.data.name === "CS"
                ? "Start your CS-EET, CS Executive and CS Professional preparation at VPA Edu Nagpur with expert guidance, study material and test series. Enroll now!"
                : this.state.data.name === "XI-XII CBSE"
                ? "Excel in Std. 11th 12th CBSE Commerce with VPA Edu. Expert teaching in Accountancy, Mathematics, Business Studies, Economics, and English."
                : this.state.data.name === "XI-XII State Board"
                ? "VPA Edu offers expert 11th–12th State Board Commerce Classes in Nagpur for Accountancy, Maths, Economics, Secretarial Practices, OCM and English."
                : "VPA Edu offers expert 11th–12th State Board Commerce Classes in Nagpur for Accountancy, Maths, Economics, Secretarial Practices, OCM and English."
            }
          />
        </Helmet>
        <Header />
        <Navbar />
        {/* <ScrollAnimation
          animateIn="fadeInUp"
          animateOut="fadeOut"
          animationInDuration={1800}
          animationOutDuration={1800}
          isVisible={true}
        > */}
        <div className="breadcumb-area bg-img" style={{ position: "relative" }}>
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/7/77/Medlibrary.jpg"
             alt={
              this.state.imgText != "" &&
              this.state.imgText != null &&
              this.state.imgText != undefined
                ? this.state.imgText
                : "Students studying together in a busy library reading room."
            }
            // alt="Students studying together in a busy library reading room."
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              position: "absolute",
              top: 0,
              left: 0,
              zIndex: 0,
            }}
          />
          <div className="bradcumbContent">
            <h2>Top Achievers</h2>
          </div>
        </div>
        {/* </ScrollAnimation> */}
        <section
          className="ftco-section bg-light achieversSetion"
          data-aos="fade-up"
        >
          <h3
            style={{
              textAlign: "center",
              marginTop: "20px",
              marginBottom: "20px",
              fontWeight: "bold",
            }}
          >
            Our{" "}
            {this.state.data.name === "XI-XII CBSE" ||
            this.state.data.name === "XI-XII State Board"
              ? "Achievers"
              : " Recent All India Ranks"}{" "}
            In {this.state.data.name}
          </h3>
          <div className="container-fluid px-4">
            {/* <ScrollAnimation
              animateIn="fadeInUp"
              animationInDuration={1800}
              animateOnce={true}
              isVisible={true}
            > */}
            <div className="row">
              {this.state.data.name === "XI-XII CBSE" ? (
                <div className="col-md-12">
                  <h3
                    style={{
                      textAlign: "center ",
                      fontWeight: "bold",
                      // paddingTop: "15px",
                      paddingBottom: "15px",
                      // marginRight:"600px",
                      // marginLeft:"600px",
                      // fontWeight:"bold",
                      marginTop: "-15px",
                    }}
                  >
                    (2025 to 2011)
                  </h3>
                  <img
                    src={img2025}
                    alt="VPA 2025 Class XII CBSE results banner showing Nagpur topper and top scorers."
                    style={{ paddingTop: "15px", width: "100%" }}
                  />
                  <img
                    src={img2024}
                    alt="VPA 2024 XII CBSE Commerce top scorers from Nagpur."
                    style={{ paddingTop: "15px", width: "100%" }}
                  />
                  <img
                    src={img2023}
                    alt="VPA 2023 XII CBSE Commerce toppers results banner."
                    style={{ paddingTop: "15px", width: "100%" }}
                  />
                  <img
                    src={img2022}
                    alt="VPA 2022 XII CBSE Commerce toppers results banner."
                    style={{ paddingTop: "15px", width: "100%" }}
                  />
                  <img
                    src={img2021}
                    alt="VPA 2021 XII CBSE Commerce toppers results banner."
                    style={{ paddingTop: "15px", width: "100%" }}
                  />
                  <img
                    src={img2020}
                    alt="VPA 2020 XII CBSE Commerce toppers results banner."
                    style={{ paddingTop: "15px", width: "100%" }}
                  />

                  <img
                    src={img2019}
                    alt="VPA 2019 XII CBSE Commerce toppers results banner."
                    style={{ paddingTop: "15px", width: "100%" }}
                  />

                  <img
                    src={img2018}
                    alt="VPA 2018 XII CBSE Commerce toppers results banner."
                    style={{ paddingTop: "15px", width: "100%" }}
                  />
                  {/* <img
                    src={img2017}
                    alt="some"
                    style={{ paddingTop: "15px", width: "100%" }}
                  /> */}
                  {/* <img
                    src={img2016}
                    alt="some"
                    style={{ paddingTop: "15px", width: "100%" }}
                  /> */}
                  {/* <img
                    src={img2015}
                    alt="some"
                    style={{ paddingTop: "15px", width: "100%" }}
                  /> */}
                  {/* <img
                    src={img2014}
                    alt="some"
                    style={{ paddingTop: "15px", width: "100%" }}
                  /> */}
                  <img
                    src={img2013}
                    alt="VPA 2013 XII CBSE Commerce toppers results banner."
                    style={{ paddingTop: "15px", width: "100%" }}
                  />
                  <img
                    src={img2012}
                    alt="VPA 2012 XII CBSE Commerce toppers results banner."
                    style={{ paddingTop: "15px", width: "100%" }}
                  />
                  <img
                    src={img2011}
                    alt="VPA 2011 XII CBSE Commerce toppers results banner."
                    style={{ paddingTop: "15px", width: "100%" }}
                  />
                </div>
              ) : this.state.data.name === "XI-XII State Board" ? (
                <div className="col-md-12">
                  <h3
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      // paddingTop: "15px",
                      paddingBottom: "15px",
                      // paddingRight:"600px",
                      // paddingLeft:"600px",
                      // fontWeight:"bold",
                      marginTop: "-15px",
                    }}
                  >
                    (2025 to 2017)
                  </h3>
                  <img
                    src={sb2025}
                    alt="VPA 2025 Std. XII State Board top scorers results banner."
                    style={{ paddingTop: "15px", width: "100%" }}
                  />
                  <img
                    src={sb2024}
                    alt="VPA 2024 Std. XII State Board top scorers results banner."
                    style={{ paddingTop: "15px", width: "100%" }}
                  />
                  <img
                    src={sb2023}
                    alt="VPA 2023 Std. XII State Board top scorers results banner."
                    style={{ paddingTop: "15px", width: "100%" }}
                  />
                  <img
                    src={sb2022}
                    alt="VPA 2022 Std. XII State Board top scorers results banner."
                    style={{ paddingTop: "15px", width: "100%" }}
                  />
                  <img
                    src={sb2021}
                    alt="VPA 2021 Std. XII State Board top scorers results banner."
                    style={{ paddingTop: "15px", width: "100%" }}
                  />
                  <img
                    src={sb2020}
                    alt="VPA 2020 Std. XII State Board top scorers results banner."
                    style={{ paddingTop: "15px", width: "100%" }}
                  />
                  <img
                    src={sb2019}
                    alt="VPA 2019 XII State Board Commerce top 10 scorers results banner"
                    style={{ paddingTop: "15px", width: "100%" }}
                  />
                  <img
                    src={sb2018}
                    alt="VPA 2018 XII State Board Commerce top 5 scorers results banner."
                    style={{ paddingTop: "15px", width: "100%" }}
                  />
                  <img
                    src={sb2017}
                    alt="VPA 2017 XII State Board Commerce successful students group photo"
                    style={{ paddingTop: "15px", width: "100%" }}
                  />
                </div>
              ) : (
                this.state.achievers.map((person, index) => (
                  <div className="col-md-6 col-lg-2" data-aos="fade-up">
                    <div className="staff">
                      <div className="img-wrap d-flex align-items-stretch">
                        <div
                          className="img align-self-stretch img_focus"
                          // style={{
                          //   backgroundImage: "url(" + person.image + ")"
                          // }}
                        >
                          <img
                            src={NewConstants.imageUrl + person.image_path}
                            width="100%"
                            alt={person.achiever_name}
                            // style={{ height: "375px" }}
                          />
                        </div>
                      </div>
                      <div className="text pt-3 text-center">
                        <div className="faded nameCenter">
                          <ul className="ftco-social text-center">
                            <h5>{person.achiever_name} </h5>
                            {/* <h5>{person.course.name} </h5> */}
                            <p tyle={{ marginTop: "" }}> {person.rank}</p>
                            <p style={{ marginTop: "" }}>
                              {person.description}
                            </p>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
            {/* </ScrollAnimation> */}
          </div>
        </section>
        <Footer />
      </div>
    );
  }
}
